export enum MessageRole {
    USER = 'USER',
    ASSISTANT = 'ASSISTANT'
}

export enum SpinnerType {
    BUBBLE = 'BUBBLE',
    PLAIN = 'PLAIN',
}

export interface AiChatUser {
    id?: string;
    name?: string;
    avatar?: string;
}

export interface AiChatMessage {
    id: string;
    message: string;
    role: MessageRole;
    timestamp: Date;
    isEdited?: boolean;
    isFavorite?: boolean;
    meta?: any;
}

export interface AiChatFavoriteTemplate {
    id: string;
    content: string;
    label?: string;
}
